// nprogress.js
import NProgress from "nprogress";
import "nprogress/nprogress.css"; // Import CSS for styling

NProgress.configure({ showSpinner: false });

export const startProgress = () => NProgress.start();
export const doneProgress = () => NProgress.done();
